import React from "react";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import BudgetDrill from "./BudgetDrill";
import PerformanceDashboardDrill from "./PerformanceDashboardDrill";
import VarianceDashboardDrill from "./VarianceDashboardDrill";

type Props = {
  open: boolean;
  request: any | null;
  onClose: () => void;
};

export default class DashboardDrillHost extends React.Component<Props> {
  renderDrillContent() {
    const { request } = this.props;

    if (!request) return null;

    if (request.dashboard === "budget") {
      return <BudgetDrill request={request} />;
    }

    // if (request.dashboard === "performance") {
    //   return <PerformanceDashboardDrill request={request} />;
    // }

    // if (request.dashboard === "variance") {
    //   return <VarianceDashboardDrill request={request} />;
    // }

    return (
      <Typography color="text.secondary">
        No drill panel registered for {request.dashboard}.
      </Typography>
    );
  }

  render() {
    const { open, request, onClose } = this.props;

    return (
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box sx={{ width: { xs: 360, md: 720 }, p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: 18 }}>
                {request?.title || "Drill-down"}
              </Typography>
              <Typography sx={{ fontSize: 12, color: "#66788A" }}>
                {request?.dashboard} · {request?.section} · {request?.drillType}
              </Typography>
            </Box>

            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {this.renderDrillContent()}
        </Box>
      </Drawer>
    );
  }
}
